import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import comingSoonIcon from '../../../../../assets/images/coming-soon-Image.jpg'
import { types } from "../../../../common/dependencies/reducer/comingSoonReducer";
import { connect } from "react-redux";
import swal from "sweetalert";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);


function CustomizedDialogs(props) {
  const { open, setOpen, setClose } = props;

  const handleClose = () => {
    setClose();
  };

  useEffect(() => {
    if(open) {
      swal('', `Dear Startup,

    Thank you for registering on MAARG. We will soon reveal your mentor match. For now, please feel free to explore the portal features and prepare your questions for the mentor! 
    
    We appreciate your patience.
    
    Warm regards,
    Startup India team`, 'info')
    setTimeout(() => {
      setClose()
    }, 500)
    }  
  }, [open])

  return (
    // <Dialog
    //   onClose={handleClose}
    //   aria-labelledby="customized-dialog-title"
    //   open={open}
    //   scroll={"body"}
    // >
    //     <IconButton style={{position: 'absolute', top: 0, right: 0}} onClick={() => setClose()}><CloseIcon style={{color: '#563a96'}} /></IconButton>
    //   <DialogContent>
    //     <div style={{ height: "400px", width: "500px", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
    //       <img src={comingSoonIcon} style={{height: '240px'}} />
    //       <Typography
    //         style={{
    //           fontFamily: "Montserrat",
    //           fontWeight: "bold",
    //           fontSize: "28px",
    //           color: "#000",
    //         }}
    //       >
    //       Stay Tuned !
    //       </Typography>
    //       <Typography
    //         style={{
    //           fontFamily: "Montserrat",
    //           fontSize: "20px",
    //           fontWeight: "bold",
    //           color: "rgba(0,0,0,0.4)",
    //         }}
    //       >
    //         This feature will be enabled very soon
    //       </Typography>
    //       <Button
    //         style={{
    //           fontFamily: "Montserrat",
    //           fontSize: "20px",
    //           fontWeight: "bold",
    //           color: "white",
    //           backgroundColor: "#563a96",
    //           borderRadius: '30px', 
    //           padding: '10px 25px', 
    //           marginTop: '20px'
    //         }}
    //         variant="contained"
    //         onClick={() => setClose()}
    //       >
    //         OK
    //       </Button>
    //     </div>
    //   </DialogContent>
    // </Dialog>
    <></>
  );
}

const mapStateToProps = (state) => {
  return {
    open: state.comingSoon.open, 
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setOpen: () => dispatch({type: types.SET_OPEN}), 
    setClose: () => dispatch({type: types.SET_CLOSE}), 
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomizedDialogs)